import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

type DetailComponentSectionProps = {
  title: string;
  children: React.ReactElement | React.ReactElement[];
};

const DetailComponentSection: React.FC<DetailComponentSectionProps> = ({title, children}) => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div className="my-2 flex flex-col gap-4">
      <div
        className={classNames(
          'border-b pb-2 text-xl font-semibold',
          hasDarkBg ? 'border-white/50' : 'border-black/50'
        )}
      >
        {title}
      </div>
      {children}
    </div>
  );
};

export default DetailComponentSection;
